export const HUB_PERMISSION = {
  SETTLEMENT_STATEMENT: {
    VBI_SUBSCRIPTION_COLUMN: "vbi_subscription_column",
    REGULATORY_FEE_COLUMN: "regulatory_fee_column",
  },
};

export const ROLE_PERMISSIONS = {
  DRIVER_DETAIL_PAGE: {
    ALLOCATIONS_COLLAPSE: {
      DM_ALLOCATION: "dm_allocation",
      VA_ALLOCATION: "va_allocation",
      ONETIME_DM_ALLOCATION: "onetime_dm_allocation",
      ONETIME_VA_ALLOCATION: "onetime_VA_ALLOCATION",
      CAR_ALLOCATION: "car_allocation",
      FETCH_AGENTS_LIST: "fetch_agents_list",
      TELECALLING_ALLOCATION: "telecalling_allocation",
      ONETIME_TELECALLING_ALLOCATION: "onetime_telecalling_allocation",
      CHILD_HUB_ALLOCATION: "child_hub_allocation",
      ONETIME_CHILD_HUB_ALLOCATION: "onetime_child_hub_allocation",
    },
    TRIP_ACTIVITY_REPORT: {
      TRIP_ACTIVITY_REPORT: "trip_activity_report",
    },
    ONBOARDING: {
      ONBOARDING: "onboarding",
      PRODUCT_TYPE: "product_type",
      ONETIME_PRODUCT_TYPE: "onetime_product_type",
      ONETIME_DRIVING_LICENCE_NUMBER: "onetime_driving_licence_number",
      DRIVING_LICENCE_NUMBER: "driving_licence_number",
      ONTEIME_DRIVING_LICENCE_ISSUE_DATE: "onetime_driving_licence_issue_date",
      DRIVING_LICENCE_ISSUE_DATE: "driving_licence_issue_date",
      ONETIME_DRIVING_LICENCE_EXPIRY_DATE: "onetime_driving_licence_expiry_date",
      DRIVING_LICENCE_EXPIRY_DATE: "driving_licence_expiry_date",
      ONETIME_AADHAR_NUMBER: "onetime_aadhar_number",
      AADHAR_NUMBER: "aadhar_number",
      ONETIME_STATUS: "onetime_status",
      STATUS: "status",
      ONETIME_ALTERNATE_PHONE_NUMBER: "onetime_alternate_phone_number",
      ALTERNATE_PHONE_NUMBER: "alternate_phone_number",
      ONETIME_DRIVER_UBER_ID: "onetime_driver_uber_id",
      DRIVER_UBER_ID: "driver_uber_id",
      ONETIME_UBER_ID_STAGE: "onetime_uber_id_stage",
      UBER_ID_STAGE: "uber_id_stage",
      ONETIME_DRIVING_LICENCE_FRONT_PIC: "onetime_driving_licence_front_pic",
      DRIVING_LICENCE_FRONT_PIC: "driving_licence_front_pic",
      ONETIME_DRIVER_LICENCE_BACK_PIC: "onetime_driver_licence_back_pic",
      DRIVER_LICENCE_BACK_PIC: "driver_licence_back_pic",
      ONETIME_DRIVER_SELFIE_PIC: "onetime_driver_selfie_pic",
      DRIVER_SELFIE_PIC: "driver_selfie_pic",
      ONETIME_AADHAR_FRONT_PIC: "onetime_aadhar_front_pic",
      AADHAR_FRONT_PIC: "aadhar_front_pic",
      ONETIME_AADHAR_BACK_PIC: "onetime_aadhar_back_pic",
      AADHAR_BACK_PIC: "aadhar_back_pic",
      ONETIME_BANK_ACCOUNT_NUMBER: "onetime_bank_account_number",
      BANK_ACCOUNT_NUMBER: "bank_account_number",
      ONETIME_BANK_IFSC_CODE: "onetime_bank_ifsc_code",
      BANK_IFSC_CODE: "bank_ifsc_code",
      ONETIME_PAN_CARD: "onetime_pan_card",
      PAN_CARD: "pan_card",
      ONETIME_CHEQUE_ACCOUNT_NUMBER: "onetime_cheque_account_number",
      CHEQUE_ACCOUNT_NUMBER: "cheque_account_number",
      ONETIME_BANK_PASSBOOK_PIC: "onetime_bank_passbook_pic",
      BANK_PASSBOOK_PIC: "bank_passbook_pic",
      ONETIME_PAN_CARD_PIC: "onetime_pancard_pic",
      PAN_CARD_PIC: "pancard_pic",
      ONETIME_CURRENT_ADDRESS_LINE_1: "onetime_current_address_line_1",
      CURRENT_ADDRESS_LINE_1: "current_address_line_1",
      ONETIME_CURRENT_ADDRESS_LINE_2: "onetime_current_address_line_2",
      CURRENT_ADDRESS_LINE_2: "current_address_line_2",
      ONETIME_LANDMARK: "onetime_landmark",
      LANDMARK: "landmark",
      ONETIME_PIN_CODE: "onetime_pin_code",
      PIN_CODE: "pin_code",
      ONETIME_STATE: "onetime_state",
      STATE: "state",
      ONETIME_CITY: "onetime_city",
      CITY: "city",
      ONETIME_ADDRESS_PROOF: "onetime_address_proof",
      ADDRESS_PROOF: "address_proof",
      ONETIME_CURRENT_ADDRESS_PROOF_NUMBER: "onetime_current_address_proof_number",
      CURRENT_ADDRESS_PROOF_NUMBER: "current_address_proof_number",
      ONETIME_ADDRESS_PROOF_PIC: "onetime_address_proof_pic",
      ADDRESS_PROOF_PIC: "address_proof_pic",
      ONETIME_ONBOARDING_REMARKS: "onetime_onboarding_remarks",
      ONBOARDING_REMARKS: "onboarding_remarks",
      DRIVING_LICENCE_FRONT_PIC_VIEW: "driving_licence_front_pic_view",
      DRIVING_LICENCE_FRONT_DOWNLOAD: "driving_licence_front_download",
      DRIVING_LICENCE_FRONT_ADD_ANOTHER: "driving_licence_front_add_another",
      DRIVING_LICENCE_BACK_PIC_VIEW: "driving_licence_back_pic_view",
      DRIVING_LICENCE_BACK_DOWNLOAD: "driving_licence_back_download",
      DRIVING_LICENCE_BACK_ADD_ANOTHER: "driving_licence_back_add_another",
      DRIVER_SELFIE_PIC_VIEW: "driver_selfie_pic_view",
      DRIVER_SELFIE_PIC_DOWNLOAD: "driver_selfie_pic_download",
      DRIVER_SELFIE_PIC_ADD_ANOTHER: "driver_selfie_pic_add_another",
      AADHAR_FRONT_PIC_VIEW: "aadhar_front_pic_view",
      AADHAR_FRONT_PIC_DOWNLOAD: "aadhar_front_pic_download",
      AADHAR_FRONT_PIC_ADD_ANOTHER: "aadhar_front_pic_add_another",
      AADHAR_BACK_PIC_VIEW: "aadhar_back_pic_view",
      AADHAR_BACK_PIC_DOWNLOAD: "aadhar_back_pic_download",
      AADHAR_BACK_PIC_ADD_ANOTHER: "aadhar_back_pic_add_another",
      BANK_PASSBOOK_PIC_VIEW: "bank_passbook_pic_view",
      BANK_PASSBOOK_PIC_DOWNLOAD: "bank_passbook_pic_download",
      BANK_PASSBOOK_PIC_ADD_ANOTHER: "bank_passbook_pic_add_another",
      PAN_CARD_PIC_VIEW: "pancard_pic_view",
      PAN_CARD_PIC_DOWNLOAD: "pancard_pic_download",
      PAN_CARD_PIC_ADD_ANOTHER: "pancard_pic_add_another",
      ADDRESS_PROOF_PIC_VIEW: "address_proof_pic_view",
      ADDRESS_PROOF_PIC_DOWNLOAD: "address_proof_pic_download",
      ADDRESS_PROOF_PIC_ADD_ANOTHER: "address_proof_pic_add_another",
      AGREEMENT_SEND_BUTTON: "agreement_send_button",
      AGREEMENT_RESEND_BUTTON: "agreement_resend_button",
      AGREEMENT_OFFLINE_BUTTON: "agreement_offline_button",
      AGREEMENT_HISTORY_BUTTON: "agreement_history_button",
    },
    VERIFICATION: {
      VERIFICATION: "verification",
    },
    STATUS: {
      STATUS: "status",
      TELECALLING_PAYMENT_STATUS: "telecalling_payment_status",
      CAR_ALLOCATION: "car_allocation",
    },
    REQUESTS: {
      SCHEME_CHANGE_REQUEST: "scheme_change_request",
      CAR_ALLOCATION: "car_allocation",
    },
    DRIVER_DETAILS: {
      DRIVER_DETAILS: "driver_details",
      FIRST_NAME: "first_name",
      ONETIME_FIRST_NAME: "onetime_first_name",
      LAST_NAME: "last_name",
      ONETIME_LAST_NAME: "onetime_last_name",
      DRIVER_SMALL_ID: "driver_small_id",
      ONETIME_DRIVER_SMALL_ID: "onetime_driver_small_id",
      PHONE: "phone",
      ONETIME_PHONE: "onetime_phone",
      EMAIL: "email",
      ONETIME_EMAIL: "onetime_email",
      LEAD_SOURCES: "lead_sources",
      ONETIME_LEAD_SOURCES: "onetime_lead_sources",
      SUB_LEAD_CATEGORY: "sub_lead_category",
      ONETIME_SUB_LEAD_CATEGORY: "onetime_sub_lead_category",
      LANGUAGES: "languages",
      ONETIME_LANGUAGES: "onetime_languages",
      CHILD_HUB_NAME: "child_hub_name",
      ONETIME_CHILD_HUB_NAME: "onetime_child_hub_name",
    },
    PAYMENT: {
      PAYMENT: "payment",
      CLICK_TO_CALL: "click_to_call",
      SEND_DISCOUNT_REQUEST: "send_discount_request",
      SEND_SETTLEMENT_STATEMENT: "send_settlement_statement",
    },
    REMARKS: {
      COMMON_REMARKS: "common_remarks",
      ONETIME_COMMON_REMARKS: "onetime_common_remarks",
    },
  },
  FLEET_DETAIL_PAGE: {
    RECEIVE: {
      // DOCUMENT_REQUIRED_SIGN:'document_required_sign',
      // IS_DOCUMENT_RQUIRED:"is_document_required"
      // REMOVE_REQUIRED_SIGN:'remove_required_sign',
      // REMOVE_DOCS_RQUIRED:'remove_required_docs'
    },
    PARKING: {
      INSURANCE_DOC_UPLOAD: "insurance_doc_upload",
      INSURANCE_DOC_VIEW: "insurance_doc_view",
      INSURANCE_DOC_DOWNLOAD: "insurance_doc_download",
      INSURANCE_DOC_ADD_ANOTHER: "insurance_doc_add_another",

      POLLUTION_DOC_UPLOAD: "pollution_doc_upload",
      POLLUTION_DOC_VIEW: "pollution_doc_view",
      POLLUTION_DOC_DOWNLOAD: "pollution_doc_download",
      POLLUTION_DOC_ADD_ANOTHER: "pollution_doc_add_another",

      FITNESS_DOC_UPLOAD: "fitness_doc_upload",
      FITNESS_DOC_VIEW: "fitness_doc_view",
      FITNESS_DOC_DOWNLOAD: "fitness_doc_download",
      FITNESS_DOC_ADD_ANOTHER: "fitness_doc_add_another",

      PERMIT_DOC_UPLOAD: "insurance_doc_upload",
      PERMIT_DOC_VIEW: "insurance_doc_view",
      PERMIT_DOC_DOWNLOAD: "insurance_doc_download",
      PERMIT_DOC_ADD_ANOTHER: "insurance_doc_add_another",

      AUTHORISATION_DOC_UPLOAD: "insurance_doc_upload",
      AUTHORISATION_DOC_VIEW: "insurance_doc_view",
      AUTHORISATION_DOC_DOWNLOAD: "insurance_doc_download",
      AUTHORISATION_DOC_ADD_ANOTHER: "insurance_doc_add_another",

      TAX_DOC_UPLOAD: "insurance_doc_upload",
      TAX_DOC_VIEW: "insurance_doc_view",
      TAX_DOC_DOWNLOAD: "insurance_doc_download",
      TAX_DOC_ADD_ANOTHER: "insurance_doc_add_another",

      RC_DOC_UPLOAD: "insurance_doc_upload",
      RC_DOC_VIEW: "insurance_doc_view",
      RC_DOC_DOWNLOAD: "insurance_doc_download",
      RC_DOC_ADD_ANOTHER: "insurance_doc_add_another",

      INVOICE_DOC_UPLOAD: "insurance_doc_upload",
      INVOICE_DOC_VIEW: "insurance_doc_view",
      INVOICE_DOC_DOWNLOAD: "insurance_doc_download",
      INVOICE_DOC_ADD_ANOTHER: "insurance_doc_add_another",

      PDI_DOC_UPLOAD: "insurance_doc_upload",
      PDI_DOC_VIEW: "insurance_doc_view",
      PDI_DOC_DOWNLOAD: "insurance_doc_download",
      PDI_DOC_ADD_ANOTHER: "insurance_doc_add_another",
    },
  },
  LEAD_DETAIL_PAGE: {
    CALL_HISTORY_BUTTON: "call_history_button",
    WALKINDONE_BUTTON: "walkindone_button",
    CALL_BUTTON: "call_button",
    HANGUP_BUTTON: "hangup_button",
    DISPOSED_BUTTON: "disposed_button",

    LEAD_DETAILS: {
      LEAD_DETAILS: "crm_lead_details",
      FIRST_NAME: "crm_first_name",
      LAST_NAME: "crm_last_name",
      DISPOSITION_CATEGORY: "crm_disposition_category",
      DISPOSITION: "crm_disposition",
      NEXT_VISIT_DATE: "crm_next_visit_date",
      NEXT_FOLLOWUP_DATE: "crm_next_followup_date",
      UBER_ID: "crm_uber_id",
      AADHAR_NUMBER: "crm_aadhar_number",
      DRIVING_LICENSE_NUMBER: "crm_driving_license_number",
      LASTEST_CALL_REASON: "crm_lastest_call_reason",
      TAG: "crm_tag",
      HUB_ID: "crm_hub_id",
      LATEST_CALL_REMARKS: "crm_latest_call_remarks",
    },
    DOCUMENTS: {
      DOCUMENTS: "documents",
      AADHAR_FRONT_PIC_UPLOAD: "crm_  aadhar_front_pic_upload",
      AADHAR_FRONT_PIC_VIEW: "crm_aadhar_front_pic_view",
      AADHAR_FRONT_PIC_DOWNLOAD: "crm_aadhar_front_pic_download",
      AADHAR_FRONT_PIC_ADD_ANOTHER: "crm_aadhar_front_pic_add_another",

      AADHAR_BACK_PIC_UPLOAD: "crm_aadhar_back_pic_upload",
      AADHAR_BACK_PIC_VIEW: "crm_aadhar_back_pic_view",
      AADHAR_BACK_PIC_DOWNLOAD: "crm_aadhar_back_pic_download",
      AADHAR_BACK_PIC_ADD_ANOTHER: "crm_aadhar_back_pic_add_another",

      DRIVING_LICENCE_FRONT_PIC_UPLOAD: "crm_driving_licence_front_pic_upload",
      DRIVING_LICENCE_FRONT_PIC_VIEW: "crm_driving_licence_front_pic_view",
      DRIVING_LICENCE_FRONT_PIC_DOWNLOAD: "crm_driving_licence_front_pic_download",
      DRIVING_LICENCE_FRONT_PIC_ADD_ANOTHER: "crm_driving_licence_front_pic_add_another",

      DRIVING_LICENCE_BACK_PIC_UPLOAD: "crm_driving_licence_back_pic_upload",
      DRIVING_LICENCE_BACK_PIC_VIEW: "crm_driving_licence_back_pic_view",
      DRIVING_LICENCE_BACK_PIC_DOWNLOAD: "crm_driving_licence_back_pic_download",
      DRIVING_LICENCE_BACK_PIC_ADD_ANOTHER: "crm_driving_licence_back_pic_add_another",

      DRIVER_SELFIE_PIC_UPLOAD: "crm_driver_selfie_pic_upload",
      DRIVER_SELFIE_PIC_VIEW: "crm_driver_selfie_pic_view",
      DRIVER_SELFIE_PIC_DOWNLOAD: "crm_driver_selfie_pic_download",
      DRIVER_SELFIE_PIC_ADD_ANOTHER: "crm_driver_selfie_pic_add_another",

      PAN_CARD_PIC_UPLOAD: "crm_pancard_pic_upload",
      PAN_CARD_PIC_VIEW: "crm_pancard_pic_view",
      PAN_CARD_PIC_DOWNLOAD: "crm_pancard_pic_download",
      PAN_CARD_PIC_ADD_ANOTHER: "crm_pancard_pic_add_another",

      BANK_PASSBOOK_PIC_UPLOAD: "crm_bank_passbook_pic_upload",
      BANK_PASSBOOK_PIC_VIEW: "crm_bank_passbook_pic_view",
      BANK_PASSBOOK_PIC_DOWNLOAD: "crm_bank_passbook_pic_download",
      BANK_PASSBOOK_PIC_ADD_ANOTHER: "crm_bank_passbook_pic_add_another",

      ADDRESS_PROOF_PIC_UPLOAD: "crm_address_proof_pic_upload",
      ADDRESS_PROOF_PIC_DOWNLOAD: "crm_address_proof_pic_download",
      ADDRESS_PROOF_PIC_VIEW: "crm_address_proof_pic_view",
      ADDRESS_PROOF_PIC_ADD_ANOTHER: "crm_address_proof_pic_add_another",
    },
  },
};
